import { DrillDesignBase } from './base/drill-design-base';

export class DrillDesign extends DrillDesignBase { }